import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  "id": undefined, // optional - Mã tự sinh
  "ho_ten": undefined, // required, minLength: 1 - Họ tên người gửi
  "dien_thoai": undefined, // optional - Số điện thoại người gửi
  "email": undefined, // optional - Email người gửi
  "noi_dung": undefined, // required, minLength: 1 - Nội dung
  "loai_loi_nhan": undefined, // optional, enum(loi_nhan, gop_y, thong_bao_loi) - Loại lời nhắn (loi_nhan: Lời nhắn trên landing page, gop_y: Góp ý trên app, thong_bao_loi: Thông báo lỗi trên app)
  "trang_thai": undefined, // optional, enum(moi, dang_xu_ly, da_xu_ly) - Trạng thái của lời nhắn
  "file_dinh_kem": undefined, // optional, ref: mushroom_file - File đính kèm
  "thoi_diem_tao": undefined, // required - Thời điểm tạo
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      ho_ten: "",
      dien_thoai: "",
      email: "",
      noi_dung: "",
      loai_loi_nhan: "",
      trang_thai: "",
      thoi_diem_tao: "",

    },
    valid: {
      thoi_diem_tao: [],
      ho_ten: [],
    },
    operator: {
      ho_ten: ":regex_i:",
      dien_thoai: ":regex_i:",
      email: ":regex_i:",
      noi_dung: ":regex_i:",
      loai_loi_nhan: "",
      trang_thai: "",
      thoi_diem_tao: ":in_that_day:",
    },
  },
};

export default model;
